var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "wrapper mt-2 mb-1/2",
      class: _vm.accessories
        ? "md:mt-0 text-2xl font-normal"
        : "md:mt-0 md:mb-0 font-medium text-2xl",
    },
    [
      _c("div", { class: _vm.accessories ? "flex" : "" }, [
        _c(
          "div",
          { staticClass: "pricing-wrapper" },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.accessories
                    ? ""
                    : _vm.activeProductKey.includes("CM")
                    ? "Starting at"
                    : ""
                ) +
                "\n      "
            ),
            _vm.smallFleetOpportunity && _vm.isAccountCreatedAfterTitan
              ? [
                  _vm.salesPriceLocal !== _vm.listPriceLocal
                    ? [
                        _c("span", {}, [
                          _vm._v(
                            _vm._s(_vm.currencySymbol.toUpperCase()) +
                              _vm._s(_vm.listPriceLocal)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", {}, [
                          _vm._v(
                            _vm._s(_vm.currencySymbol.toUpperCase()) +
                              _vm._s(_vm.salesPriceFormattedPricing) +
                              " due at\n            checkout"
                          ),
                        ]),
                      ]
                    : [
                        _c("span", {}, [
                          _vm._v(
                            _vm._s(_vm.currencySymbol.toUpperCase()) +
                              _vm._s(_vm.salesPriceFormattedPricing) +
                              " due at\n            checkout"
                          ),
                        ]),
                      ],
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.activeProductInfo.defaultOffering
                    .toLowerCase()
                    .includes("license")
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "roboto text-sm mt-1/2 leading-tight text-blue-dark",
                        },
                        [
                          _vm._v(
                            "\n          Approximately " +
                              _vm._s(_vm.currencySymbol.toUpperCase()) +
                              _vm._s(
                                Math.round(_vm.salesPriceFormattedPricing / 36)
                              ) +
                              "/month for 3 year license\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              : _vm.salesPriceLocal !== _vm.listPriceLocal
              ? [
                  _c(
                    "span",
                    {
                      staticClass: "roboto text-blue-dark",
                      class: _vm.accessories ? "font-normal" : "font-medium",
                      attrs: { id: "offer-list-price" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.currencySymbol.toUpperCase()) +
                          _vm._s(_vm.listPriceLocal)
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "roboto leading-7 text-blue-dark",
                      class: _vm.accessories ? "font-normal" : "font-medium",
                      attrs: { id: "offer-sales-price" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.currencySymbol.toUpperCase()) +
                          _vm._s(_vm.salesPriceFormattedPricing)
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "font-bold roboto leading-7 text-blue-dark",
                          attrs: { id: "offer-payment-term" },
                        },
                        [
                          _vm._v(
                            "/" + _vm._s(_vm.activeOffer.defaultPaymentTerm)
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              : [
                  _c(
                    "span",
                    {
                      staticClass: "roboto leading-7 text-blue-dark",
                      class: _vm.accessories ? "font-normal" : "font-medium",
                      attrs: { id: "offer-sales-price" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.currencySymbol.toUpperCase()) +
                          _vm._s(_vm.salesPriceFormattedPricing)
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "roboto leading-7 text-blue-dark",
                          class: _vm.accessories
                            ? "font-normal"
                            : "font-medium",
                          attrs: { id: "offer-payment-term" },
                        },
                        [
                          _vm._v(
                            " / " +
                              _vm._s(_vm.activeOffer.defaultPaymentTerm) +
                              "\n            " +
                              _vm._s(_vm.currencyIsoCode)
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
          ],
          2
        ),
        _vm._v(" "),
        !_vm.isProductGenerallyAvailable &&
        !_vm.activeProductKey.includes("CBL")
          ? _c(
              "div",
              {
                staticClass: "product-status-wrapper cursor-pointer relative",
                class: [
                  _vm.accessories ? "" : "core-product-status",
                  (_vm.activeOffer.productStatus === "Out of stock" ||
                    _vm.activeProductKey === "AG46 Battery Replacement Pack") &&
                    "out-out-stock",
                ],
                attrs: { id: "product-status" },
                on: {
                  mouseover: function ($event) {
                    _vm.showDetail = true
                  },
                  mouseleave: function ($event) {
                    _vm.showDetail = false
                  },
                },
              },
              [
                _c("div", { staticClass: "error-circle" }, [_vm._v("!")]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.activeOffer.productStatus))]),
                _vm._v(" "),
                _vm.showDetail
                  ? _c("div", { staticClass: "status-details" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.webstoreContent.webstoreBody[
                              _vm.snakeCase(_vm.activeOffer.productStatus)
                            ]
                          ) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section-margin-1" }, [
        _vm.activeProductInfo.advisoryMessage
          ? _c("p", { staticClass: "font-medium roboto" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.activeProductInfo.advisoryMessage) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }